export const shouldAutoSelectBankAccount = ({
  paymentForm,
  selectedBankAccountId,
  bankAccounts,
  contract = null,
  paymentFormType
}) => {
  return (
    paymentForm === paymentFormType &&
    !selectedBankAccountId &&
    Array.isArray(bankAccounts) &&
    bankAccounts.length > 0 &&
    bankAccounts[0]?.id &&
    (!contract || contract.bankAccountId == null)
  );
};

export const getFirstBankAccountId = bankAccounts => {
  if (!Array.isArray(bankAccounts) || bankAccounts.length === 0) {
    return null;
  }
  return bankAccounts[0]?.id || null;
};

export const getFirstCreditCardId = creditCards => {
  if (!Array.isArray(creditCards) || creditCards.length === 0) {
    return null;
  }
  return creditCards[0]?.id || null;
};

export const getInitialBankAccountIdForDialog = ({
  paymentForm,
  paymentFormType,
  selectedBankAccountId,
  validBankAccounts
}) => {
  const shouldAutoSelect =
    paymentForm === paymentFormType &&
    !selectedBankAccountId &&
    validBankAccounts.length > 0;

  if (shouldAutoSelect) {
    return getFirstBankAccountId(validBankAccounts);
  }

  return selectedBankAccountId;
};

export const hasNoPaymentMethodSelected = ({
  paymentForm,
  automaticDebitType,
  creditCardType,
  bankTransferType,
  selectedBankAccountId,
  selectedCardId
}) => {
  if (!paymentForm || paymentForm === '') {
    return true;
  }

  if (paymentForm === automaticDebitType && !selectedBankAccountId) {
    return true;
  }

  if (paymentForm === creditCardType && !selectedCardId) {
    return true;
  }

  if (
    paymentForm !== automaticDebitType &&
    paymentForm !== creditCardType &&
    paymentForm !== bankTransferType
  ) {
    return true;
  }

  return false;
};
